import React, { useEffect } from 'react'
import moment from 'moment';
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import MenuItem from '@mui/material/MenuItem';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { getPartnerGuid } from '../../../../../lib/access.es6';
import { PARTNERS_WITH_CAUSE_OF_DEATH_CAPTURE } from '../../../../../routes/PartnersEnum';
import { CAUSES_OF_DEATH, causeOfDeathFromBenefits } from '../../utils/causeOfDeath';

const DeathClaimDetails = (props) => {
  const classes = useStyle();

  const member = props.member;
  const additionalDetails = props.claimInitiationPayload.additional_details || {};
  const derivedCause = causeOfDeathFromBenefits(props.claimInitiationPayload.benefits);
  const capturesCauseOfDeath = PARTNERS_WITH_CAUSE_OF_DEATH_CAPTURE.includes(getPartnerGuid());

  const getAge = () => {
    return member ? moment(props.eventDate).diff(moment(member.date_of_birth), 'years') : '';
  };

  const setAdditionalDetail = (name, value) => {
    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["additional_details"] = {
      ...additionalDetails,
      age: getAge(),
      [name]: value,
    };
    props.setClaimInitiationPayload(tempClaimInitiation);
  }

  useEffect(() => {
    if (capturesCauseOfDeath && derivedCause && !additionalDetails.cause_of_death) {
      setAdditionalDetail('cause_of_death', derivedCause);
    }
  }, [derivedCause]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!member) {
    return <p>Select a member on the previous step to continue.</p>
  }

  const selectSx = {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.005em",
    color: "#000000",
  };

  const renderSelect = (label, name, options, value, onChange) => (
    <Grid item xs={12} md={4} sm={4}>
      <SelectValidator
        id={name}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        style={{ width: "100%" }}
        variant="outlined"
        sx={selectSx}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option} sx={selectSx}>{option}</MenuItem>
        ))}
      </SelectValidator>
    </Grid>
  );

  const renderYesNo = (label, name) => {
    const answer = additionalDetails[name];
    return renderSelect(
      label,
      name,
      ['Yes', 'No'],
      answer === true ? 'Yes' : answer === false ? 'No' : '',
      (event) => setAdditionalDetail(name, event.target.value === 'Yes')
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Deceased details</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="first_name"
              name='first_name'
              value={member.first_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="middle_name"
              style={{ width: "100%" }}
              label="middle_name"
              name='middle_name'
              value={member.middle_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="last_name"
              style={{ width: "100%" }}
              label="last_name"
              name='last_name'
              value={member.last_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="relationship"
              style={{ width: "100%" }}
              label="relationship"
              name='relationship'
              value={member.relationship}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="gender"
              style={{ width: "100%" }}
              label="gender"
              name='gender'
              value={member.gender}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_birth"
              style={{ width: "100%" }}
              label="date_of_birth"
              name='date_of_birth'
              value={member.date_of_birth}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="age"
              style={{ width: "100%" }}
              label="age"
              name='age'
              value={getAge()}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_death"
              style={{ width: "100%" }}
              label="date_of_death"
              name='date_of_death'
              value={props.eventDate}
              variant="outlined"
            />
          </Grid>

        </Grid>

        {capturesCauseOfDeath && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <div className={classes.headingclaim}>
                  <h4>Circumstances of death</h4>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2} className={classes.selectpolicyWrapper}>
              {renderSelect(
                'Cause of death',
                'cause_of_death',
                CAUSES_OF_DEATH,
                additionalDetails.cause_of_death || '',
                (event) => setAdditionalDetail('cause_of_death', event.target.value)
              )}

              <Grid item xs={12} md={4} sm={4}>
                <TextValidator
                  id="location_of_death"
                  style={{ width: "100%" }}
                  label="Location / Hospital"
                  name='location_of_death'
                  value={additionalDetails.location_of_death || ''}
                  onChange={(event) => setAdditionalDetail('location_of_death', event.target.value)}
                  variant="outlined"
                />
              </Grid>

              {renderYesNo('Suffered any chronic condition?', 'suffered_chronic_condition')}
              {renderYesNo('Hospitalized?', 'hospitalized')}
            </Grid>
          </>
        )}

      </ValidatorForm>
    </>
  )
}

export default DeathClaimDetails
